export { SvgIcon } from "./svg-icon.component";
export type { ISvgIconProps } from "./svg-icon.component";
